import { Suspense } from "react";
import CommonRoutesWrapper from "components/CommonRoutesWrapper";
import { createBrowserRouter, RouterProvider } from "react-router";

import AppLayout from "features/layout/AppLayout";
import PageLoadingFallback from "features/layout/PageLoadingFallback";

import { RouteConfig } from "services/routesConfig";

import { routesConfig } from "./routesConfig";

export const RouteComponent = ({ config }: { config: RouteConfig }) => {
  if (config.insecure) {
    return config.component;
  }

  return (
    <AppLayout routeConfig={config}>
      <Suspense fallback={<PageLoadingFallback />}>
        {config.component!}
      </Suspense>
    </AppLayout>
  );
};

const InstanceManagementRoutes = () => {
  const displayedRoutes = Object.entries(routesConfig);

  const securedRoutes = displayedRoutes
    .filter(([, config]) => !config.insecure)
    .map(([, config]) => ({
      path: config.path,
      element: <RouteComponent config={config} />,
    }));

  const insecureRoutes = displayedRoutes
    .filter(([, config]) => config.insecure)
    .map(([, config]) => ({
      path: config.path,
      element: <RouteComponent config={config} />,
    }));

  const routerConfig = [
    ...insecureRoutes,
    {
      element: <CommonRoutesWrapper />,
      children: securedRoutes,
    },
  ];

  const router = createBrowserRouter(routerConfig);

  return <RouterProvider router={router} />;
};

export default InstanceManagementRoutes;
